// @ts-nocheck

import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { AboutPage, ContactPage, LandingPage } from 'components/pages';
import ScrollToTop from 'components/ScrollToTop';
import GenesisHome from 'components/pages/GenesisHome';
import EnigmaHome from 'components/pages/EnigmaHome';
import FuturaMixpass from 'components/pages/FuturaMixpass';
import FuturaToken from 'components/pages/FuturaToken';
import FuturaRedemptionPage from 'components/pages/FuturaRedemptionPage';
import FuturaGallery from 'components/pages/FuturaGallery';
import TokenPage from 'components/pages/TokenPage';
import GenesisCapture from 'components/pages/GenesisCapture';
import EnigmaCapture from 'components/pages/EnigmaCapture';
import Stake from 'components/pages/StakePage';
import MyEBCollection from 'components/pages/MyEBCollection';
import TraitsPage from 'components/pages/TraitsPage';
import RemixPage from 'components/pages/RemixPage';
import FuturaPlayer from 'components/pages/FuturaPlayer';
import { remixEnabled } from 'utils/config';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';
import { WalletItemsContextProvider } from 'components/WalletItemsContext';

const Routes = () => {
  return (
    <Router>
      <QueryParamProvider adapter={ReactRouter5Adapter}>
        <ScrollToTop />
        <Switch>
          <Route exact path="/">
            <LandingPage />
          </Route>

          <Route path="/genesis/:id?">
            <WalletItemsContextProvider>
              <GenesisHome />
            </WalletItemsContextProvider>
          </Route>

          <Route path="/enigma/:id?">
            <WalletItemsContextProvider>
              <EnigmaHome />
            </WalletItemsContextProvider>
          </Route>

          <Route path="/futura/redeem" exact>
            <FuturaRedemptionPage />
          </Route>

          <Route path="/futura/player" exact>
            <FuturaPlayer />
          </Route>

          <Route path="/futura/gallery" exact>
            <FuturaGallery />
          </Route>

          <Route path="/futura/mixpass" exact>
            <FuturaMixpass />
          </Route>

          <Route path="/futura/traits" exact>
            <TraitsPage />
          </Route>

          <Route path="/futura/details/:id">
            <FuturaToken />
          </Route>

          {remixEnabled && (
            <Route exact path="/futura/remix">
              <RemixPage />
            </Route>
          )}

          <Route path="/futura/:id">
            <FuturaPlayer />
          </Route>

          <Route exact path="/token/:id">
            <TokenPage />
          </Route>

          <Route exact path="/image/genesis/:id">
            <WalletItemsContextProvider>
              <GenesisCapture />
            </WalletItemsContextProvider>
          </Route>
          <Route exact path="/image/enigma/:id">
            <WalletItemsContextProvider>
              <EnigmaCapture />
            </WalletItemsContextProvider>
          </Route>

          {remixEnabled && (
            <Route exact path="/remixstudio">
              <RemixPage />
            </Route>
          )}

          <Route exact path="/about">
            <AboutPage />
          </Route>

          <Route exact path="/contact">
            <ContactPage />
          </Route>

          <Route exact path="/stake">
            <Stake />
          </Route>

          <Route exact path="/my-collection">
            <MyEBCollection />
          </Route>
        </Switch>
      </QueryParamProvider>
    </Router>
  );
};

export default Routes;
